import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap align-center ga-2" }
const _hoisted_2 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}

import { computed, ref } from "vue";
import { ViewPartidaAmistosaDTO } from "@/interfaces/Partidas";
import { useAuth } from "@/composables/useAuth";
import { useToast } from "@/composables/useToast";
import { cancelarPartida, ValidarPartida } from "@/services/PartidasAmistosasService";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";
import CardPartidaLectura from "@/components/Commons/CardPartidaLectura.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingMatchCard',
  props: {
    match: {}
  },
  emits: ["registroExitoso"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// registroExitoso: la partida ha cambiado y hay que volver a cargar la lista
const emit = __emit;

const { getUser, getidUsuario } = useAuth();
const { triggerToast } = useToast();
const idUsuario = computed(() => Number(getidUsuario.value));

const soyJugador1 = computed(() => props.match.idUsuario1 === idUsuario.value);
const validadaPorMi = computed(() =>
  soyJugador1.value ? props.match.partidaValidadaUsuario1 : props.match.partidaValidadaUsuario2
);
const nickRival = computed(() =>
  soyJugador1.value ? props.match.nickUsuario2 : props.match.nickUsuario1
);

const validando = ref(false);
const cancelando = ref(false);
const confirmarCancelar = ref(false);

const validar = async () => {
  validando.value = true;
  try {
    await ValidarPartida({
      emailJugador: getUser.value ?? "",
      idPartida: props.match.idPartidaAmistosa,
    });
    triggerToast("success", "Partida validada");
    emit("registroExitoso");
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido validar la partida");
  } finally {
    validando.value = false;
  }
};

const cancelar = async () => {
  confirmarCancelar.value = false;
  cancelando.value = true;
  try {
    await cancelarPartida(props.match.idPartidaAmistosa);
    triggerToast("success", "Partida cancelada");
    emit("registroExitoso");
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido cancelar la partida");
  } finally {
    cancelando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CardPartidaLectura, {
      contexto: ['Pendiente', _ctx.match.esElo ? 'ELO' : ''].filter(Boolean).join(' · '),
      fecha: _unref(formatFechaSpaWhitoutAsync)(_ctx.match.fechaPartida),
      jugador1: {
      idUsuario: _ctx.match.idUsuario1,
      nick: _ctx.match.nickUsuario1,
      ejercito: _ctx.match.ejercitoUsuario1,
      puntos: _ctx.match.resultadoUsuario1,
    },
      jugador2: {
      idUsuario: _ctx.match.idUsuario2,
      nick: _ctx.match.nickUsuario2,
      ejercito: _ctx.match.ejercitoUsuario2,
      puntos: _ctx.match.resultadoUsuario2,
    },
      escenario: _ctx.match.escenarioPartida,
      puntosPartida: _ctx.match.puntosPartida,
      idGanador: _ctx.match.ganadorPartida,
      idUsuarioDestacado: idUsuario.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!validadaPorMi.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "success",
                variant: "flat",
                size: "small",
                "prepend-icon": "mdi-check",
                loading: validando.value,
                disabled: cancelando.value,
                onClick: validar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Validar ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, " Esperando a que " + _toDisplayString(nickRival.value) + " la valide ", 1)),
          _createVNode(_component_v_btn, {
            variant: "text",
            color: "error",
            size: "small",
            class: "ml-auto",
            loading: cancelando.value,
            disabled: validando.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmarCancelar.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancelar ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["contexto", "fecha", "jugador1", "jugador2", "escenario", "puntosPartida", "idGanador", "idUsuarioDestacado"]),
    _createVNode(_component_v_dialog, {
      modelValue: confirmarCancelar.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmarCancelar).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-wrap" }, {
              default: _withCtx(() => [
                _createTextVNode("¿Cancelar la partida?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" La partida contra " + _toDisplayString(nickRival.value) + " se borrará y no contará para nada. ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmarCancelar.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Volver")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: cancelar
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar partida")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})